import styled from 'styled-components';

export const Content = styled.div``;

/* Alignment and nothing else — see the note in the user list's copy. */
export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }
`;

/*
 * The category thumbnail — the design's `.thumb`: a 30px rounded square with
 * a hairline, the same object the menu tables draw.
 *
 * It used to be a 40px circle that shrank to 32px for a child row. The size
 * step is gone: the indent and the chevron already say where a row sits in
 * the tree, and two thumb sizes down one column read as two kinds of thing
 * rather than one thing at two depths. The `.child` class is still passed by
 * the component and now changes nothing.
 */
export const Icon = styled.div`
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  margin: auto;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: var(--surface-alt);
  overflow: hidden;
  line-height: 0;
`;

/*
 * The expand/collapse affordance.
 *
 * The design file has no tree table, so this follows the sidebar's chevron
 * instead — the only other disclosure control in the product: a quiet
 * --text-faint glyph that rotates 180 degrees when its branch is open and
 * takes --primary while it is. It replaces a filled grey circle that turned
 * cyan, which was pre-redesign and read as a status dot rather than a
 * control. Flagged in FINDINGS as a judgement call.
 */
export const ArrowIcon = styled.div`
  display: grid;
  place-items: center;
  flex: 0 0 var(--s4);
  width: var(--s4);
  height: var(--s4);
  line-height: 0;
  color: var(--text-faint);
  transition:
    transform 0.16s,
    color 0.12s;

  svg {
    width: var(--s3);
    height: var(--s3);
  }
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

/* The title truncates; the chevron beside it must not. */
export const TitleText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/*
 * A row's title, and the row's indent.
 *
 * The indent lives here rather than in the table because it is padding on a
 * div inside the cell — which is why `table-layout: fixed` does not disturb
 * it. One --s5 per level, replacing a 20px step that was on no scale. Six
 * levels, matching the six the component stamps.
 */
export const TitleTd = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  min-width: 0;
  font-size: var(--fs-body);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  text-align: left;
  color: var(--text);

  &.child,
  &.level-2 {
    padding-left: var(--s5);
  }

  &.level-3 {
    padding-left: calc(var(--s5) * 2);
  }

  &.level-4 {
    padding-left: calc(var(--s5) * 3);
  }

  &.level-5 {
    padding-left: calc(var(--s5) * 4);
  }

  &.level-6 {
    padding-left: calc(var(--s5) * 5);
  }

  &.active .child-arrow-icon {
    transform: rotate(180deg);
    color: var(--primary);
  }
`;
